export { StoreFrontAlt as default } from './StoreFrontAlt';
